ready(function () {

  const filterCoursesEl = document.getElementById('filterCourses');
  if (filterCoursesEl) {
    
    htmx.on('htmx:afterSwap', function(event) {
      if (event.target.querySelector('#filterCourses')) {
        setTimeout(attachSelectWidthHandler, 100);
      }
    });

    function attachSelectWidthHandler() {
      document.querySelectorAll("#filterCourses select").forEach(select => {
        const updateWidth = () => {
          const tempSpan = document.createElement("span");
          tempSpan.style.visibility = "hidden";
          tempSpan.style.position = "absolute";
          tempSpan.style.whiteSpace = "nowrap";
          tempSpan.style.font = getComputedStyle(select).font;
          tempSpan.innerText = select.options[select.selectedIndex].text;
          document.body.appendChild(tempSpan);
          select.style.width = `${tempSpan.offsetWidth + 24}px`;
          document.body.removeChild(tempSpan);
        };
        updateWidth();
        select.addEventListener("change", updateWidth);
      });
    }

    attachSelectWidthHandler();
  }

});